import Page from '../components/Page';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Application({
  children
}) {
  return /*#__PURE__*/_jsx(Page, {
    children: children
  });
}